export default {"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111};